/* src/app/views/visit/visit-link/visit-link.component.css */
::ng-deep p-rating svg {
  color: #ffbb00;
  height: 25px;
  width: 28px;
}
/*# sourceMappingURL=visit-link.component.css.map */
